import { render, staticRenderFns } from "./GChatMessageBlock.vue?vue&type=template&id=9ff1c9d4&"
import script from "./GChatMessageBlock.vue?vue&type=script&lang=ts&"
export * from "./GChatMessageBlock.vue?vue&type=script&lang=ts&"
import style0 from "./GChatMessageBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports